import { ApiNotification, Notification } from '../models/notification';
import { ApiSeverity } from '../../enums/api-severity.enum';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ParticipantOffersUrlBuilderService } from '../../services/participant-offers-url-builder.service';
import { Severity } from '../../enums/severity.enum';
import { map } from 'rxjs/operators';

const convertApiSeverityToSeverity = (
  apiSeverity: ApiSeverity | undefined
): Severity | undefined => {
  if (apiSeverity === undefined) return undefined;

  const severityMapping: Record<ApiSeverity, Severity> = {
    [ApiSeverity.Information]: Severity.Information,
    [ApiSeverity.Success]: Severity.Success,
    [ApiSeverity.Warning]: Severity.Warning,
    [ApiSeverity.Error]: Severity.Error,
  };

  return severityMapping[apiSeverity];
};

@Injectable({
  providedIn: 'root'
})
export class NotificationMpsService {
  public onChange: Subject<void> = new Subject<void>();

  constructor(
    private _urlBuilder: ParticipantOffersUrlBuilderService,
    private _http: HttpClient
  ) {}

  getNotifications(): Observable<Notification[]> {
    const url = this._urlBuilder.getTenderPlatformAbsoluteUrl('/api-gateway/alerts/user-alerts/alerts');
    return this._http.get<ApiNotification[]>(url).pipe(
      map((notifications: ApiNotification[]) =>
        notifications.map((notification: ApiNotification) => ({
          ...(notification as any),
          severity: convertApiSeverityToSeverity(notification.severity),
        } as Notification))
      )
    );
  }
  public async handle(): Promise<void> {
    this.onChange.next();
  }
}
